import { AbstractControl } from '@angular/forms';

export function postalcodeValidator(control: AbstractControl): { [key: string]: any } | null {
  const valid = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i.test(control.value);
  return valid ? null : { invalidValue: { valid: false, value: control.value } };
}
